/**
 * 보스 예약 시간(reserve time) 관련 쿼리·뮤테이션.
 * signup/pickup-time, pre-order/pickup-time-update에서 재사용.
 */
import { gql } from "@apollo/client";

export const UPDATE_RESERVE_TIME = gql`
  mutation UpdateReserveTime($id: Int!, $reserveTime: Json, $reason: String) {
    updateReserveTime(id: $id, reserveTime: $reserveTime, reason: $reason) {
      id
      reserveTime
    }
  }
`;
